/** Switch component - toggle switch input. */

"use client";

import * as React from "react";
import * as SwitchPrimitives from "@radix-ui/react-switch";

import { cn } from "@/lib/utils";

type SwitchProps = React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> & { label?: string };

const Switch = React.forwardRef<React.ElementRef<typeof SwitchPrimitives.Root>, SwitchProps>(({ className, label, id, ...props }, ref) => {
  const control = (
    <SwitchPrimitives.Root
      id={id}
      className={cn(
        ("peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none" +
          "focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50" +
          "data-[state=checked]:bg-primary data-[state=unchecked]:bg-input"),
        className,
      )}
      {...props}
      ref={ref}
    >
      <SwitchPrimitives.Thumb
        className={cn("pointer-events-none block h-5 w-5 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0")}
      />
    </SwitchPrimitives.Root>
  );
  if (!label) return control;
  return (
    <label className="inline-flex items-center gap-2 text-sm font-medium text-foreground" htmlFor={id}>
      {control}
      <span>{label}</span>
    </label>
  );
});
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
